module.exports = __webpack_public_path__ + "img/GALERIA-XL7-2021-1.e33efb34.jpg";